import { render, staticRenderFns } from "./BannerDialog.vue?vue&type=template&id=5788b27f"
import script from "./BannerDialog.vue?vue&type=script&lang=js"
export * from "./BannerDialog.vue?vue&type=script&lang=js"
import style0 from "./BannerDialog.vue?vue&type=style&index=0&id=5788b27f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports